var _defs, _rect, _path, _path2, _path3, _g, _g2, _g3, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 2400,
    height: 712.8455149197998,
    viewBox: "81.3543487548828 98.670556640625 177.2913024902344 52.658879089355466",
    preserveAspectRatio: "xMidYMid meet",
    colorInterpolationFilters: "sRGB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 92,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fa71cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9b59b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 93,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f83600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 94,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0064d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1cb0f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 95,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f00978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3f51b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 96,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7873f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ec77ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 97,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e14fad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 98,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#009efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2af598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 99,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffcc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00b140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 100,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d51007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff8177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 102,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a2b6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c3483"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 103,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7ac5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#eea2a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 104,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ecbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#007adf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 105,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b88746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fdf5a6"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#feffff",
    className: "iconlinesvg-g iconlinesvg",
    transform: "translate(83.09249877929688,100.40871047973633)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "tp-name"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "imagesvg"
  }, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#feffff",
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 49.186513409327404,
    height: 49.182578803023155,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 49.186513409327404,
    height: 49.182578803023155,
    filtersec: "colorsb9417351230",
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127.44999694824219 127.44000244140625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B46C2",
    d: "M127.44 127.44H0V0l127.44 127.44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#825EE4",
    d: "M65.07 0h62.38v127.14H65.07z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00234b",
    d: "M65.07 65.07v62.37h62.37L65.07 65.07z"
  })))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(56, 0.24878940151157636)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#feffff",
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.48 0.58Q15.28 0.58 11.12-1.72Q6.96-4.03 4.58-8.26Q2.21-12.48 2.21-18.00L2.21-18.00Q2.21-23.53 4.65-27.76Q7.08-31.98 11.31-34.29Q15.54-36.59 20.73-36.59L20.73-36.59Q25.94-36.59 30.16-34.29Q34.38-31.98 36.82-27.76Q39.26-23.53 39.26-18.00L39.26-18.00Q39.26-12.48 36.76-8.26Q34.26-4.03 30.00-1.72Q25.74 0.58 20.48 0.58L20.48 0.58ZM20.48-7.35Q22.95-7.35 25.12-8.55Q27.30-9.75 28.60-12.16Q29.90-14.56 29.90-18.00L29.90-18.00Q29.90-23.14 27.20-25.90Q24.51-28.67 20.61-28.67L20.61-28.67Q16.71-28.67 14.07-25.90Q11.44-23.14 11.44-18.00L11.44-18.00Q11.44-12.87 14.01-10.11Q16.57-7.35 20.48-7.35L20.48-7.35Z",
    transform: "translate(-2.21, 48.1)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(97, 0.24878940151157636)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#feffff",
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.15-18.14Q2.15-23.60 4.32-27.82Q6.50-32.05 10.27-34.32Q14.04-36.59 18.66-36.59L18.66-36.59Q22.16-36.59 25.35-35.07Q28.54-33.54 30.42-31.01L30.42-31.01L30.42-48.10L39.65-48.10L39.65 0L30.42 0L30.42-5.33Q28.73-2.67 25.68-1.04Q22.62 0.58 18.59 0.58L18.59 0.58Q14.04 0.58 10.27-1.76Q6.50-4.09 4.32-8.35Q2.15-12.61 2.15-18.14L2.15-18.14ZM30.48-18.00Q30.48-21.32 29.19-23.69Q27.89-26.07 25.68-27.33Q23.46-28.60 20.93-28.60L20.93-28.60Q18.39-28.60 16.25-27.37Q14.11-26.13 12.77-23.76Q11.44-21.39 11.44-18.14L11.44-18.14Q11.44-14.88 12.77-12.45Q14.11-10.01 16.28-8.71Q18.46-7.41 20.93-7.41L20.93-7.41Q23.46-7.41 25.68-8.68Q27.89-9.95 29.19-12.32Q30.48-14.69 30.48-18.00L30.48-18.00Z",
    transform: "translate(-2.145, 48.1)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(138, 0.24878940151157636)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#feffff",
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.96-18.79Q37.96-16.84 37.70-15.28L37.70-15.28L11.38-15.28Q11.70-11.38 14.11-9.17Q16.51-6.96 20.02-6.96L20.02-6.96Q25.09-6.96 27.23-11.31L27.23-11.31L37.05-11.31Q35.49-6.11 31.07-2.76Q26.65 0.58 20.21 0.58L20.21 0.58Q15.02 0.58 10.89-1.72Q6.76-4.03 4.45-8.26Q2.15-12.48 2.15-18.00L2.15-18.00Q2.15-23.60 4.42-27.82Q6.70-32.05 10.79-34.32Q14.88-36.59 20.21-36.59L20.21-36.59Q25.35-36.59 29.41-34.38Q33.48-32.18 35.72-28.11Q37.96-24.05 37.96-18.79L37.96-18.79ZM11.44-21.39L28.54-21.39Q28.47-24.89 26-27.01Q23.53-29.12 19.96-29.12L19.96-29.12Q16.57-29.12 14.27-27.07Q11.96-25.03 11.44-21.39L11.44-21.39Z",
    transform: "translate(-2.145, 48.1)"
  })))))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    "v-gra": "od"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.c7165cc761adc1f868ad12ee19ae83bc.svg";
export { ForwardRef as ReactComponent };